var React = require('react');

function EqualSosaRegular (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(1 0 0 -1 0 1540)"},React.createElement("path",{"fill":"currentColor","d":"M383 -88h299v-299h-299v299zM383 -387l86 43h170v170l43 86l-84 -86v-127h-129zM725 -45l86 43h170v170l43 86l-86 -86v-127h-127zM725 -45v299h299v-299h-299zM725 -88h299v-299h-299v299zM725 -387l86 43h170v170l43 86l-86 -86v-127h-127zM1067 -88h299v-299h-299v299\nzM1067 -387l84 43h172v170l43 86l-86 -86v-127h-129zM1067 487l84 43h172v172l43 84l-86 -84v-129h-129zM1067 487v299h299v-299h-299zM1067 829l84 43h172v170l43 86l-86 -86v-127h-129zM1067 829v299h299v-299h-299zM1407 147l86 43h170v170l43 86l-84 -86v-129h-129z\nM1407 147v299h299v-299h-299zM1407 487v299h299v-299h-299zM1407 487l86 43h170v172l43 84l-84 -84v-129h-129z"})));
}

EqualSosaRegular.defaultProps = {"version":"1.1","viewBox":"-10 0 2058 2048"};

module.exports = EqualSosaRegular;

EqualSosaRegular.default = EqualSosaRegular;
